import type { ContentPage } from "@/lib/content/types";

// CRM › Salesforce Automation › Account Management (leaf).
export const accountManagement: ContentPage = {
  slug: "salesforce-automation/account-management",
  template: "hrmsFeature",
  seo: {
    title: "Account Management Software - Manage Customer Accounts | GetBiz CRM",
    description:
      "Manage companies, hierarchies, contacts and deals together with GetBiz CRM account management software. The complete view B2B and key-account teams need.",
    keywords: [
      "account management software",
      "key account management software",
      "customer account management",
      "B2B account management",
      "CRM account management",
      "company management software",
    ],
    ogImage: "/assets/data/seoimages/account-management.webp",
  },
  leaf: {
    hero: {
      caption: "Account Management",
      title: "Manage Every Account From a Single View",
      description:
        "See each company with all its contacts, deals, activities and hierarchy in one place — so account and B2B teams always know where every relationship stands.",
      h1: "caption",
    },
    split: {
      title: "The Complete Picture of Every Account",
      bullets: [
        { title: "Company Records", description: "One record per company with all related contacts and deals." },
        { title: "Account Hierarchies", description: "Map parent-child relationships across subsidiaries and branches." },
        { title: "Activity Timeline", description: "Every interaction with the account, in chronological order." },
        { title: "Account Health", description: "Track revenue, open deals and engagement per account." },
      ],
      image: "/assets/images/img/product/crm/crm-account-management.webp",
      imageAlt: "GetBiz CRM account management software",
    },
    cardsHeading: {
      title: "Works With the Rest of Salesforce Automation",
      description:
        "Account Management connects to every other part of your GetBiz CRM sales workflow.",
    },
    cards: [
      { title: "Contact Management", href: "/crm-software/salesforce-automation/contact-management/", description: "Group and manage all the contacts within each account.", image: "/assets/images/img/product/crm/contact-management-image.webp", imageAlt: "CRM contact management" },
      { title: "Deal Management", href: "/crm-software/salesforce-automation/deal-management/", description: "Track every deal tied to an account across your pipeline.", image: "/assets/images/img/product/crm/deal-management-image-Photoroom.webp", imageAlt: "CRM deal management" },
      { title: "Lead Management", href: "/crm-software/salesforce-automation/lead-management/", description: "Connect new leads to existing accounts automatically.", image: "/assets/images/img/product/crm/lead-managemnet-crm.webp", imageAlt: "CRM lead management" },
      { title: "Workflow Management", href: "/crm-software/salesforce-automation/workflow-management/", description: "Automate account updates, reviews and renewal tasks.", image: "/assets/images/img/product/crm/workflow-image.webp", imageAlt: "CRM workflow management" },
    ],
    testimonials: {
      title: "Grow key accounts with GetBiz CRM",
      description: "See why B2B teams trust GetBiz to manage their accounts.",
    },
    bookDemoTitle: "See every account clearly, in one place.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "key-account-management-guide, b2b-account-management-strategies",
    metaKey: "account-management",
  },
  sections: [],
};
